import getRandomString from './getRandomString';
import { getItem, removeItem, setItem } from './localStorageFn';

const authTokenName = 'fcWPAuthToken';
const refreshTokenName = 'fcWPRefreshToken';
const deviceKey = 'fewcentWPDeviceKey';

const setAuthToken = (accessToken) => setItem(authTokenName, accessToken);

const removeAuthToken = () => {
  removeItem('balance_before_paypal');
  removeItem(authTokenName);
};

const removeRefreshToken = () => removeItem(refreshTokenName);

const getAuthToken = () => {
  const authToken = getItem(authTokenName);
  if (authToken === 'null') {
    removeAuthToken();
    removeRefreshToken();
    return undefined;
  }
  return authToken;
};

const setRefreshToken = (refreshToken) =>
  setItem(refreshTokenName, refreshToken);

const getRefreshToken = () => {
  const refreshToken = getItem(refreshTokenName);
  if (refreshToken === 'null') {
    removeRefreshToken();
    return undefined;
  }
  return refreshToken;
};

const getOrCreateDeviceIdentity = () => {
  const fewcentDeviceKey = getItem(deviceKey);

  if (fewcentDeviceKey) {
    return fewcentDeviceKey;
  }
  const uid = getRandomString(15);
  setItem(deviceKey, uid);
  return uid;
};

const getDeviceIdentity = () => getItem(deviceKey);

const setDeviceIdentity = (value) => setItem(deviceKey, value);

const removeDeviceIdentity = () => removeItem(deviceKey);

export {
  setAuthToken,
  getAuthToken,
  removeAuthToken,
  setRefreshToken,
  getRefreshToken,
  removeRefreshToken,
  getOrCreateDeviceIdentity,
  getDeviceIdentity,
  setDeviceIdentity,
  removeDeviceIdentity,
};
